import { LinkBehavior } from 'ui'

import {
  MuiButton,
  MuiLink,
  MuiSelect,
  MuiPopover,
  MuiInputBase,
  MuiInputLabel,
  MuiTextField,
  MuiOutlinedInput,
  MuiStepLabel,
  MuiDrawer,
  MuiIconButton,
  MuiAlert,
  MuiTab,
  MuiStep,
  MuiDatePicker,
} from './componentsMui'

export const components = {
  MuiButton,
  MuiLink,
  MuiButtonBase: {
    defaultProps: {
      LinkComponent: LinkBehavior,
    },
  },
  MuiSelect,
  MuiPopover,
  MuiInputLabel,
  MuiTextField,
  MuiInputBase,
  MuiOutlinedInput,
  MuiStepLabel,
  MuiDrawer,
  MuiIconButton,
  MuiAlert,
  MuiTab,
  MuiStep,
  MuiDatePicker,
}
